export default __webpack_public_path__ + "static/media/camel_cavalry.0986464d.png";